// --------------------------------------------------------
// src/views/alphaFilter.view.js
//
// Manage the view/template for the alphabetical filter
//
// --------------------------------------------------------
"use strict";

const ALPHA_FILTER_TEMPLATE = `
	<nav>
		<ul class="inline-list">
			<li class="results"></li>
			<% for (var i = 0; i < alphabet.length; i++) { %>
				<% if (!_.contains(active, alphabet[i].toUpperCase() )) %>
					<li><a class="alphaFilter disabled"><%= alphabet[i] %></a></li>
				<% else { %>
					<li><a class="alphaFilter <% if (selected == alphabet[i]) { %>active<% } %>"><%= alphabet[i] %></a></li>
				<% } %>
			<% } %>
		</ul>
	</nav>
`;

// The view for a single book model
const AlphaFilterComponent = Backbone.View.extend({

    id: "alphaMenu",

    className: "ptop-20",

    components: {
        bookCounter: {}
    },

    // Bind event listeners
    events: {
        "click a.alphaFilter": "update",
    },

    // This object can receive any kind of collection
    // This attribute is useful to know which to look for when rendering the template
    keyMapping: "title",

    // The selected letter
    selected: null,

    // The className for the Model
    modelClassName: "bookListItem my-20 hvr-shrink col-lg-3 col-md-6 col-sm-6 col-xs-12 p0",

    // Converts the template to html
    template: _.template(ALPHA_FILTER_TEMPLATE),

    // Initialize the alphabet and books collection
    initialize: function (options) {
        this.options = options || {};
        this.keyMapping = options.keyMapping || "title";
        // required for the event bubbling.
        // cloning this.collection will trigger an unwanted re-render.
        this.filteredCollection = this.collection.clone();
        this.components.bookCounter = new BookCounterComponent({ collection: this.collection.clone() });
        // Keep a copy of the original collection which should not be manipulated
        this.originalCollection = this.collection.clone();
        // genCharArray defined in helpers/extension.js
        this.alphabet = genCharArray("a", "z");
        // The list of active letters (inactive if no book start with the letter)
        this.active = this.genAlphabetArray(this.collection);
        // The currently selected letter (null means none)
        this.selected = null;

        // Re-render the component upon changes on the collection
        this.listenTo(this.collection, "update reset destroy", this.reRender);
        this.proxy = new Proxy(this, this.watcher);
    },

    reRender: function () {
        this.active = this.genAlphabetArray(this.collection);
        this.components.bookCounter.collection.set(this.collection.clone().models);
        this.render();
    },

    // Render the template
    render: function () {
        this.$el.html(this.template(this));
        this.$el.find("li.results").html(this.components.bookCounter.render().el);

        return this;
    },

    // Generate an array of unique letters from the titles in the collection
    genAlphabetArray: function (collection) {
        // Get all the titles from the books
        let titles = collection.toJSON().map((el) => {
            return el[this.keyMapping].slice(0, 1);
        });

        // Remove the duplicates and sort the array by alphabetical order
        return _.uniq(titles).sort();
    },

    // Filter the book that start with a specific letter
    sortByAlpha: function () {
        // A null letter returns all the books
        // It should mean that the previously selected letter was selected again
        return this.selected === null ?
            this.originalCollection.models :
            this.originalCollection.reject((el) => {
                return !(el.attributes[this.keyMapping].charAt(0).toUpperCase() === this.selected.toUpperCase());
            }).sort((a, b) => {
                return (a.attributes[this.keyMapping].toLowerCase() < b.attributes[this.keyMapping].toLowerCase()) ? -1 :
                    (a.attributes[this.keyMapping].toLowerCase() > b.attributes[this.keyMapping].toLowerCase()) ? 1 :
                        0;
            });
    },

    // Update the books on the page
    update: function (e) {
        e.preventDefault();
		// The selected letter becomes null if it was clicked again
		this.proxy.selected = this.selected === $(e.target).text() ?
			null :
			$(e.target).text();

		let event = new CustomEvent("letter", {
			bubbles: true,
			detail: {
				letter: () => this.selected,
				collection: () => this.filteredCollection.clone().set(this.sortByAlpha())
			}
		});
		this.components.bookCounter.collection.set(this.sortByAlpha());
        this.$el.find("li.results").html(this.components.bookCounter.render().el);

        this.el.dispatchEvent(event);
    },

    watcher: {
        set: function (target, prop, newValue) {
            // When the selected property is modified, we need to re-render the template again to display the selected letter
            // the collection might not always be updated which means the re-render function might not be called.
            if (prop === "selected") {
                target.selected = newValue;
                target.render();

                return true;
            }

            return false;
        }
    }

});
